export default __webpack_public_path__ + "static/media/hybridge.616186f6.png";